import { DefaultTheme } from 'react-native-paper';

const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: '#23abdc', // Cambia el color primario si lo deseas
    background: 'white', // Establece el fondo en blanco
    primaryLight: '#daedf5',
    surfaceVariant: "white",
    secondaryContainer: "#F1F1F1",
    surface: "#fff",
    onBackground: "#fff",
    surfaceVariant: "#fff",
    error: "#c23b22",
    success: "#9dd6ad",
    warning: "#ffb347",
    danger: "#e2504c", //danger: "#e2504c",
    dangerLight: "#ff9688",
    inversePrimary: '#23abdc',
    gray: "#999"
  },
  banner:{
    fontSize: 20,
    textAlign: 'left',
    fontWeight: 'bold',
    marginLeft: -20
  },
  buttons:{
    error:{
      color: 'white',
      backgroundColor: "#c23b22",
    },    
  },
  cards:{
    padding: 10,
    margin: 10,
    borderRadius: 15,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.58,
    shadowRadius: 3.84,
    elevation: 5,
  },
  buttonCards:{
    width: 150,
    height: 150,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.10,
    shadowRadius: 3.84,
    elevation: 5,
    margin: 10,
    padding: 10,
    borderRadius: 15,
  },
  buttonCardsSmall:{
    width: "100px",
    height: "100px",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.10,
    shadowRadius: 3.84,
    elevation: 5,
    margin: 10,
    padding: 10,
    borderRadius: 15,
  },
  storeCardTitle:{
    fontSize: 18, 
    color: 'white', 
    fontWeight: 'bold', 
    textTransform: 'uppercase', 
    alignItems: 'center', 
    justifyContent: 'center',
    textShadowColor: 'rgba(0, 0, 0, 0.1)',
    textShadowOffset: {width: 1, height: 1},
    textShadowRadius: 1 
  },
  storeCardTitleSmall:{
    fontSize: 15, 
    color: 'white', 
    textTransform: 'uppercase', 
    alignItems: 'center', 
    justifyContent: 'center',
    textShadowColor: 'rgba(0, 0, 0, 0.1)',
    textShadowOffset: {width: 1, height: 1},
    textShadowRadius: 1 
  },
  storeCardText:{
    fontSize: 15, 
    color: 'white', 
    fontWeight: 'bold', 
    textTransform: 'uppercase', 
    alignItems: 'center', 
    justifyContent: 'center',
    textShadowColor: 'rgba(0, 0, 0, 0.3)',
    textShadowOffset: {width: 1, height: 1},
    textShadowRadius: 1
  },
  containerGrid2:{
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonContentCards:{
    paddingTop: 35,
    textAlign: 'center',
  },
  buttonContentCardsSmall:{
    paddingTop: 25,
    textAlign: 'center',
  },
  buttonContentText:{
    textAlign: 'center', 
    fontSize: 17, 
    marginTop: 5
  },
  buttonContentTextSmall:{
    textAlign: 'center', 
    fontSize: 15, 
    marginTop: 5
  },
  floatingButton:{
    bottom: 16,
    right: 16,
    position: 'fixed',
    backgroundColor: '#daedf5',
  },
  containerSkeleton: {
    padding: 10,
  },
  subTitle: {
    fontSize: 20,
    color: 'black',
  },
  subTitle2: {
    fontSize: 18,
    color: 'black',
  },
  subTitle3: {
    fontSize: 15,
    color: 'black',
  },
  imageLoginContainer: {
    width: 150,
    height: 50
  }
};

export default theme;